/* SHOPS-AUTOMATION-MEGAMENU-HOVER-INTENT v1
 * ---------------------------------------------------------------------------
 * Hover-intent ("menu-aim") dla megamenu w motywie Horizon 3.4.0.
 *
 * WADA (zmierzona na zywo, gronnhage.no + gamingshop.no, 1440x900):
 *   Idac po prostej od etykiety kategorii (y 54..98) do podkategorii w LEWEJ
 *   kolumnie panelu (y 108..171, x 40..), kursor musi przejsc przez WIERSZ
 *   NAGLOWKA na wysokosci linkow. Sa tam dwa rodzaje pulapek:
 *     - SASIEDNIE pozycje top-level: pointerenter -> HeaderMenu.activate ->
 *       panel przelacza sie na inna kategorie i uzytkownik klika link z cudzego
 *       panelu (zmierzone: cel "Stablestoler", pod kursorem "Loungesett"
 *       z panelu "Hagemobelsett"),
 *     - INNE KOLUMNY NAGLOWKA (logo, wyszukiwarka): kursor opuszcza <li>
 *       na wysokosci y 88..98, czyli POWYZEJ pasa latanego przez CSS, wiec
 *       leci pointerleave -> HeaderMenu.deactivate -> panel znika w locie.
 *   Dodatkowo pointerleave na sasiedzie tez wola deactivate, ktory zamyka
 *   AKTYWNY panel (bo #deactivate domyslnie bierze this.#state.activeItem).
 *   Docstring mowi "Deactivate the active item after a delay", ale opoznienia
 *   w kodzie nie ma. isMovingWithinMenu wymaga document.activeElement w menu
 *   (przy myszy to <body>), isMovingToSubmenu wymaga event.type === 'blur' -
 *   oba warunki sa martwe dla myszy.
 *
 * MECHANIZM LATKI (bez dotykania kodu motywu):
 *   Horizon deleguje pointerenter/pointerleave z DOCUMENT w fazie CAPTURE
 *   (assets/component.js -> registerEventListeners). Faza capture idzie
 *   window -> document -> ... -> target, wiec listener na WINDOW w capture
 *   zawsze wykonuje sie PRZED listenerem motywu, niezaleznie od kolejnosci
 *   ladowania skryptow i od minifikacji CDN. Przechwytujemy wiec zdarzenia na
 *   window, decydujemy czy przepuscic (stopPropagation = nie przepuszczamy),
 *   a gdy chcemy wywolac akcje motywu z opoznieniem - re-dispatchujemy
 *   syntetyczny PointerEvent na tym samym <li> z flaga pass-through.
 *   Zero zaleznosci od prywatnych pol (#state), od nazw metod po minifikacji
 *   ani od modulu ESM. Stan czytamy z DOM (aria-expanded), tak jak zapisuje go
 *   sam motyw.
 *
 * REGULY:
 *   (a) OPOZNIONA AKTYWACJA - pointerenter na INNYM top-level przy otwartym
 *       panelu nie przelacza od razu:
 *         - jesli wektor ruchu schodzi w dol (dy >= AIM_MIN_DY) i promien ruchu
 *           trafia w gorna krawedz otwartego panelu, a kursor jest jeszcze NAD
 *           panelem -> uznajemy ze uzytkownik "celuje" w panel i IGNORUJEMY
 *           przelot; sprawdzamy ponownie co AIM_RECHECK ms,
 *         - jesli kursor sie zatrzyma (brak wektora) albo przestanie celowac
 *           -> przelaczamy,
 *         - zejscie musi byc MONOTONICZNE (AIM_STRAIGHT), zeby drgania reki
 *           przy ruchu wzdluz paska nie udawaly zjazdu do panelu,
 *         - ruch WZDLUZ paska (dy ~ 0) nie jest celowaniem -> przelaczenie po
 *           krotkim SWITCH_DELAY.
 *   (b) OPOZNIONA DEZAKTYWACJA - kazdy pointerleave z <li> jest polykany;
 *       zamkniecie planujemy sami dla AKTYWNEJ pozycji:
 *         - powrot na <li> lub na panel anuluje,
 *         - dopoki kursor wedruje po STREFIE MENU (naglowek + widoczny panel
 *           + ZONE_PAD) nie zamykamy w ogole - to wlasnie ratuje przejscie
 *           przez logo/wyszukiwarke,
 *         - po wyjsciu poza strefe zamykamy po CLOSE_DELAY ms,
 *         - bezruch w strefie dluzszy niz CLOSE_IDLE tez zamyka.
 *   (d) TYLKO DESKTOP - #header-component[data-menu-style='menu'] oraz
 *       matchMedia('(min-width: 750px)') oraz pointerType mouse/pen.
 *       Na mobile (drawer) skrypt nie tyka ani jednego zdarzenia.
 *   (e) WYKRYWALNOSC - window.__saMegamenuHoverIntent === '1' oraz atrybut
 *       data-sa-hover-intent="1" na #header-component (marker w komentarzu nie
 *       przezylby minifikacji, tak samo jak w megamenu_fix.css).
 *
 * DEGRADACJA: kazdy handler jest w try/catch; pierwszy wyjatek trwale wylacza
 * latke i zdejmuje listenery -> menu zachowuje sie dokladnie jak dzis.
 * Gdy struktura DOM sie zmieni (inne klasy/atrybuty) itemFor() zwraca null
 * i latka jest no-opem.
 *
 * UWAGA: latka JS NIE zastepuje scripts/theme_patches/megamenu_fix.css.
 * CSS mostkuje martwy pas ~11 px miedzy dolem linku a gora panelu (WADA 1),
 * JS rozwiazuje przelot nad sasiadami w wierszu linkow (WADA 2). Obie sa
 * potrzebne.
 */
(function () {
  'use strict';

  var W = typeof window !== 'undefined' ? window : null;
  if (!W || !W.document || !W.addEventListener) return;
  var D = W.document;

  /* --- idempotencja: drugi <script> nic nie robi ------------------------- */
  if (W.__saMegamenuHoverIntent) return;

  /* --- kalibracja (wartosci zmierzone, patrz raport T1-T7) --------------- */
  var CFG = {
    SWITCH_DELAY: 90,    // ms - przejscie NIE celujace w panel (ruch wzdluz paska)
    AIM_RECHECK: 110,    // ms - co ile weryfikujemy "celowanie"
    AIM_MAX_HOLD: 2000,  // ms - bezpiecznik anty-zawieszenie (nie zwykly sufit)
    CLOSE_DELAY: 160,    // ms - zwloka przed zamknieciem, gdy kursor jest POZA strefa menu
    CLOSE_POLL: 60,      // ms - co ile sprawdzamy, czy kursor opuscil strefe menu
    CLOSE_IDLE: 500,     // ms - bezruch w strefie menu tez konczy sie zamknieciem
    TRACK_MS: 260,       // ms - okno probek do wyliczenia wektora ruchu
    TRACK_MAX: 16,       // ile probek trzymamy
    AIM_MIN_DY: 2,       // px - minimalne zejscie w dol, zeby uznac celowanie
    AIM_STRAIGHT: 0.6,   // dy/dyPath - zejscie ma byc monotoniczne, nie drganiem reki
    AIM_MAX_T: 30,       // ile "dlugosci wektora" wolno leciec do panelu
    AIM_SLACK: 24,       // px - tolerancja poza boczne krawedzie panelu
    BAND_PAD: 4,         // px - tolerancja nad gorna krawedzia panelu
    ZONE_PAD: 6,         // px - margines strefy menu (naglowek + panel)
    MIN_MOVE_SQ: 9,      // px^2 - ponizej tego kursor uznajemy za stojacy
    MQ: '(min-width: 750px)'
  };

  var ITEM_CLASS = 'menu-list__list-item';
  var ATTR_ENTER = 'on:pointerenter';
  var MENU_TAG = 'header-menu';
  var HEADER_SEL = 'header-component';

  var STATS = { suppressedEnter: 0, suppressedLeave: 0, replayedEnter: 0, replayedLeave: 0, errors: 0 };

  W.__saMegamenuHoverIntent = '1';
  W.__saMegamenuHoverIntentConfig = CFG;   // pozwala kalibrowac z testu
  W.__saMegamenuHoverIntentStats = STATS;

  var disabled = false;
  var passThrough = false;          // true tylko na czas naszego dispatchEvent
  var track = [];                   // [{x, y, t}]
  var openTimer = 0, openLi = null, openDeadline = 0;
  var closeTimer = 0, closeLi = null, closeMenu = null;

  function now() {
    return (W.performance && W.performance.now) ? W.performance.now() : Date.now();
  }

  /* ---------------------------------------------------------------- utils */

  function isElement(node) {
    return !!node && node.nodeType === 1;
  }

  /** <li> paska menu, ktory motyw obsluguje przez delegacje - albo null. */
  function itemFor(event) {
    var t = event.target;
    if (!isElement(t)) return null;
    if (!t.classList || !t.classList.contains(ITEM_CLASS)) return null;
    if (!t.hasAttribute || !t.hasAttribute(ATTR_ENTER)) return null;
    return t;
  }

  function menuFor(li) {
    return li.closest ? li.closest(MENU_TAG) : null;
  }

  function headerFor(menu) {
    return (menu && menu.closest && menu.closest(HEADER_SEL)) || D.querySelector(HEADER_SEL);
  }

  /**
   * Motyw traktuje <li slot="more"> ("Mer") jako alias pierwszej pozycji
   * <li slot="overflow"> (findMenuItem w header-menu.js). Normalizujemy tak
   * samo, zeby porownania "to ta sama pozycja?" byly zgodne ze stanem motywu.
   */
  function norm(li) {
    if (!li) return null;
    if (li.getAttribute && li.getAttribute('slot') === 'more') {
      var parent = li.parentElement;
      var overflow = parent && parent.querySelector('[slot="overflow"]');
      if (overflow) return overflow;
    }
    return li;
  }

  /** Aktywna pozycja czytana z DOM - motyw sam zapisuje tam swoj stan. */
  function activeItem(menu) {
    if (!menu || !menu.querySelector) return null;
    var a = menu.querySelector('[ref="menuitem"][aria-expanded="true"]');
    if (!a || !a.closest) return null;
    return a.closest('.' + ITEM_CLASS);
  }

  function submenuOf(li) {
    if (!li || !li.querySelector) return null;
    var sub = li.querySelector('[ref="submenu[]"]');
    return isElement(sub) ? sub : null;
  }

  function desktop(event) {
    if (event && event.pointerType && event.pointerType !== 'mouse' && event.pointerType !== 'pen') return false;
    var hc = D.querySelector(HEADER_SEL);
    if (!hc || !hc.dataset || hc.dataset.menuStyle !== 'menu') return false;
    if (!W.matchMedia || !W.matchMedia(CFG.MQ).matches) return false;
    if (hc.getAttribute('data-sa-hover-intent') !== '1') hc.setAttribute('data-sa-hover-intent', '1');
    return true;
  }

  /* --------------------------------------------------------- wektor ruchu */

  function push(x, y) {
    if (typeof x !== 'number' || typeof y !== 'number') return;
    track.push({ x: x, y: y, t: now() });
    if (track.length > CFG.TRACK_MAX) track.splice(0, track.length - CFG.TRACK_MAX);
  }

  function lastPoint() {
    return track.length ? track[track.length - 1] : null;
  }

  /**
   * Netto przemieszczenie w oknie TRACK_MS. null = kursor stoi / brak danych.
   * dyPath = suma |dy| po probkach; iloraz dy/dyPath mowi, czy zejscie w dol
   * jest monotoniczne (swiadomy zjazd do panelu) czy to drgania reki przy
   * ruchu wzdluz paska.
   */
  function vector() {
    var n = track.length;
    if (n < 2) return null;
    var last = track[n - 1];
    if (now() - last.t > CFG.TRACK_MS) return null;      // kursor stoi
    var first = n - 1;
    for (var i = n - 1; i >= 0; i--) {
      if (last.t - track[i].t <= CFG.TRACK_MS) first = i;
      else break;
    }
    var oldest = track[first];
    var dx = last.x - oldest.x, dy = last.y - oldest.y;
    if (dx * dx + dy * dy < CFG.MIN_MOVE_SQ) return null;
    var dyPath = 0;
    for (var j = first + 1; j < n; j++) dyPath += Math.abs(track[j].y - track[j - 1].y);
    return { dx: dx, dy: dy, dyPath: dyPath, x: last.x, y: last.y };
  }

  /** Widoczny (po clip-path) prostokat otwartego panelu. */
  function panelBox(menu, li) {
    var sub = submenuOf(li);
    if (!sub || !sub.getBoundingClientRect) return null;
    var r = sub.getBoundingClientRect();
    if (!r || r.width <= 0 || r.height <= 0) return null;
    var hc = headerFor(menu);
    var top = r.top;
    if (hc && hc.getBoundingClientRect) {
      var hr = hc.getBoundingClientRect();
      if (hr.bottom > top) top = hr.bottom;              // panel jest przyciety clip-path
    }
    if (r.bottom - top < 8) return null;
    return { left: r.left, right: r.right, top: top, bottom: r.bottom };
  }

  /**
   * Czy kursor "celuje" w otwarty panel? Trzy warunki:
   *   1. schodzi w dol o >= AIM_MIN_DY w oknie TRACK_MS,
   *   2. to zejscie jest MONOTONICZNE (dy >= AIM_STRAIGHT * dyPath) - drgania
   *      reki przy ruchu wzdluz paska daja dy ~ 0 przy duzym dyPath i sa tu
   *      odsiewane, wiec T4 nie zwalnia,
   *   3. promien z aktualnej pozycji wzdluz wektora przecina gorna krawedz
   *      panelu w jego obrysie (AIM_MAX_T ogranicza absurdalnie plaskie tory).
   */
  function aiming(menu, active) {
    var v = vector();
    if (!v || v.dy < CFG.AIM_MIN_DY) return false;        // nie schodzi w dol
    if (v.dyPath > 0 && v.dy < CFG.AIM_STRAIGHT * v.dyPath) return false;
    var box = panelBox(menu, active);
    if (!box) return false;
    if (v.y > box.top + CFG.BAND_PAD) return false;       // juz na wysokosci panelu
    var t = (box.top - v.y) / v.dy;
    if (!isFinite(t) || t < 0 || t > CFG.AIM_MAX_T) return false;
    var xHit = v.x + v.dx * t;
    return xHit >= box.left - CFG.AIM_SLACK && xHit <= box.right + CFG.AIM_SLACK;
  }

  /**
   * Strefa menu = naglowek + widoczny panel (+ margines). Dopoki kursor jest
   * w srodku, panel NIE jest zamykany: pomiedzy dolem linku a panelem lezy nie
   * tylko latany pas ~11 px, ale tez cale kolumny naglowka (logo, wyszukiwarka),
   * przez ktore przechodzi naturalna trajektoria do lewej kolumny panelu.
   */
  function menuZone(menu, li) {
    var hc = headerFor(menu);
    if (!hc || !hc.getBoundingClientRect) return null;
    var hr = hc.getBoundingClientRect();
    var z = { left: hr.left, right: hr.right, top: hr.top, bottom: hr.bottom };
    var box = panelBox(menu, li);
    if (box) {
      z.left = Math.min(z.left, box.left);
      z.right = Math.max(z.right, box.right);
      z.bottom = Math.max(z.bottom, box.bottom);
    }
    var m = CFG.ZONE_PAD;
    return { left: z.left - m, right: z.right + m, top: z.top - m, bottom: z.bottom + m };
  }

  function inZone(z, p) {
    return !!z && !!p && p.x >= z.left && p.x <= z.right && p.y >= z.top && p.y <= z.bottom;
  }

  /* -------------------------------------------------- syntetyczne odtwarzanie */

  function replay(li, type) {
    var p = lastPoint() || { x: 0, y: 0 };
    var ev;
    try {
      ev = new W.PointerEvent(type, {
        bubbles: false, cancelable: false, composed: true,
        clientX: p.x, clientY: p.y, pointerType: 'mouse', isPrimary: true
      });
    } catch (e) {
      ev = D.createEvent('Event');
      ev.initEvent(type, false, false);
    }
    passThrough = true;
    try {
      li.dispatchEvent(ev);
    } finally {
      passThrough = false;
    }
  }

  /* ------------------------------------------------------------- harmonogram */

  function clearOpen() {
    if (openTimer) { W.clearTimeout(openTimer); openTimer = 0; }
    openLi = null; openDeadline = 0;
  }

  function clearClose() {
    if (closeTimer) { W.clearTimeout(closeTimer); closeTimer = 0; }
    closeLi = null; closeMenu = null;
  }

  // Callbacki timerow MUSZA byc opakowane tym samym guardem co handlery -
  // inaczej wyjatek w openTick/closeTick uciekalby poza latke i zostawial
  // stan w polowie drogi (przypisane nizej, tuz przed montazem listenerow).
  var openTickG, closeTickG;

  function scheduleOpen(li, delay) {
    if (openLi === li && openTimer) return;               // petla recheck juz chodzi
    clearOpen();
    openLi = li;
    openDeadline = now() + CFG.AIM_MAX_HOLD;
    openTimer = W.setTimeout(openTickG, delay);
  }

  function openTick() {
    openTimer = 0;
    if (disabled || !openLi) return;
    var li = openLi;
    if (!li.isConnected) { clearOpen(); return; }
    var menu = menuFor(li);
    var active = menu ? activeItem(menu) : null;
    if (!menu || !active) { clearOpen(); return; }        // panel juz zamkniety
    if (norm(active) === norm(li)) { clearOpen(); return; }
    if (!li.matches(':hover')) { clearOpen(); return; }   // kursor juz gdzie indziej
    // Celowanie samo sie konczy: vector() gasnie po TRACK_MS bezruchu, a ruch
    // w bok/w gore od razu daje aiming()=false. AIM_MAX_HOLD jest tylko
    // bezpiecznikiem na wypadek patologii (np. zdarzenia bez timestampow).
    if (now() < openDeadline && aiming(menu, active)) {
      openTimer = W.setTimeout(openTickG, CFG.AIM_RECHECK);
      return;
    }
    clearOpen();
    STATS.replayedEnter++;
    replay(li, 'pointerenter');
  }

  function scheduleClose(menu, li) {
    clearClose();
    closeLi = li; closeMenu = menu;
    closeTimer = W.setTimeout(closeTickG, CFG.CLOSE_DELAY);
  }

  function closeTick() {
    closeTimer = 0;
    if (disabled || !closeLi) return;
    var li = closeLi, menu = closeMenu;
    if (!li.isConnected) { clearClose(); return; }
    var active = menu ? activeItem(menu) : null;
    if (!active || norm(active) !== norm(li)) { clearClose(); return; }  // stan sie zmienil
    if (li.matches(':hover')) { clearClose(); return; }                  // kursor wrocil
    // Kursor wciaz wedruje po strefie menu (naglowek/panel) -> czekamy dalej.
    var p = lastPoint();
    if (p && (now() - p.t) <= CFG.CLOSE_IDLE && inZone(menuZone(menu, li), p)) {
      closeTimer = W.setTimeout(closeTickG, CFG.CLOSE_POLL);
      return;
    }
    clearClose();
    STATS.replayedLeave++;
    replay(li, 'pointerleave');
  }

  /* ---------------------------------------------------------------- handlery */

  function stop(event) {
    if (event.stopPropagation) event.stopPropagation();
  }

  function onMove(event) {
    push(event.clientX, event.clientY);
  }

  function onEnter(event) {
    if (passThrough) return;
    var li = itemFor(event);
    if (!li) return;
    push(event.clientX, event.clientY);
    if (!desktop(event)) return;
    var menu = menuFor(li);
    if (!menu) return;
    var active = activeItem(menu);

    clearClose();                                         // wrocilismy do menu

    if (!active) { clearOpen(); return; }                 // nic nie otwarte -> natychmiast
    if (norm(active) === norm(li)) { clearOpen(); return; }

    // przelaczanie na INNA kategorie - nigdy natychmiast
    STATS.suppressedEnter++;
    stop(event);
    scheduleOpen(li, aiming(menu, active) ? CFG.AIM_RECHECK : CFG.SWITCH_DELAY);
  }

  function onLeave(event) {
    if (passThrough) return;
    var li = itemFor(event);
    if (!li) return;
    push(event.clientX, event.clientY);
    if (!desktop(event)) return;
    var menu = menuFor(li);
    if (!menu) return;
    var active = activeItem(menu);
    if (!active) return;                                  // nic do zamkniecia

    if (openLi === li) clearOpen();                       // zeszlismy z kandydata

    // Motyw zamknalby tu panel NATYCHMIAST (a przy wyjsciu z sasiada zamknalby
    // cudzy, aktywny panel) - polykamy zdarzenie i sami pilnujemy zamkniecia.
    // Uwaga: pilnujemy AKTYWNEJ pozycji, nie opuszczanej. Inaczej scenariusz
    // "A otwarte -> najazd na sasiada B -> wyjazd z B poza naglowek" zostawilby
    // panel A otwarty na zawsze (onEnter na B kasuje harmonogram zamkniecia).
    STATS.suppressedLeave++;
    stop(event);
    scheduleClose(menu, active);
  }

  /* ------------------------------------------------------- montaz / demontaz */

  var bound = [];

  function cleanup() {
    clearOpen(); clearClose();
    for (var i = 0; i < bound.length; i++) {
      try { W.removeEventListener(bound[i][0], bound[i][1], bound[i][2]); } catch (e) { /* noop */ }
    }
    bound = [];
    W.__saMegamenuHoverIntent = 'disabled';
  }

  function guard(fn) {
    return function (event) {
      if (disabled) return;
      try {
        fn(event);
      } catch (err) {
        disabled = true;
        STATS.errors++;
        cleanup();
        if (W.console && W.console.warn) W.console.warn('[sa-megamenu-hover-intent] wylaczone:', err);
      }
    };
  }

  function on(type, fn, opts) {
    var h = guard(fn);
    W.addEventListener(type, h, opts);
    bound.push([type, h, opts]);
  }

  openTickG = guard(openTick);
  closeTickG = guard(closeTick);

  on('pointermove', onMove, { capture: true, passive: true });
  on('pointerenter', onEnter, true);
  on('pointerleave', onLeave, true);

  // marker wykrywalny ze storefrontu, gdy naglowek juz jest w DOM
  try {
    var hc0 = D.querySelector(HEADER_SEL);
    if (hc0 && hc0.dataset && hc0.dataset.menuStyle === 'menu') hc0.setAttribute('data-sa-hover-intent', '1');
  } catch (e) { /* noop */ }
})();
